import React from "react";
import textWeight from "../../utils/textWeight";
import { fontSizes } from "../../constants/constants";
import { Text } from "../index";
const FormHeading = ({
  title,
  highlightText,
  description,
  secondDescription1,
  secondDescription2,
  secondDescription3,
  secondDescription4,
  secondDescription5,
}) => {
  const { TextWeight } = textWeight();
  return (
    <div className="text-center">
      <div className="flex justify-center items-center pb-1 sm:pb-2">
        <div className="w-12 sm:w-14 lg:w-24 h-1.5 rounded-full bg-primary"></div>
        <Text
          text={
            <>
              {title}{" "}
              <Text
                text={highlightText}
                color="text-primary"
                isCenter={true}
                isTruncate={false}
                className={"inline"}
              />
            </>
          }
          size={fontSizes.h30}
          weight={TextWeight.Raleway_ExtraBold}
          color="text-black"
          isCenter={true}
          isTruncate={false}
          className={"mx-4 lg:mx-10 inline"}
        />
        <div className="w-12 sm:w-14 lg:w-24 h-1.5 rounded-full bg-primary"></div>
      </div>
      <Text
        text={description}
        size={fontSizes.h18}
        weight={TextWeight.Raleway_SemiBold}
        color="text-black"
        isCenter={true}
        isTruncate={false}
        className={"px-2 sm:px-10 mb-3"}
      />
      {[
        secondDescription1,
        secondDescription2,
        secondDescription3,
        secondDescription4,
        secondDescription5,
      ]
        .filter(Boolean)
        .map((desc, idx) => (
          <Text
            key={idx}
            text={`• ${desc}`}
            size={fontSizes.h16}
            weight={TextWeight.Raleway_SemiBold}
            color="text-black"
            align={"text-start"}
            isTruncate={false}
            className="px-2 sm:px-10 lg:px-8 list-disc space-y-1"
          />
        ))}
    </div>
  );
};
export default FormHeading;
